import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICategoryResource } from "../types";

export type ICategoryQueryParameters = {
    category?: RelationalValue<ICategoryResource>;
    locale?: string;
};

export type ICategoryQueryResult = ICategoryResource;

export const categoryQuery: IApiQueryFunction<ICategoryQueryParameters> = ({ category, locale }) => {
    if (!category) {
        return;
    }

    return {
        method: "GET",
        url: `/categories/${mapRelationalValue(category)}`,
        ...(locale ? { headers: { "x-locale": locale } } : {}),
    };
};

export const useCategoryQuery = createApiQueryHook<ICategoryQueryParameters, ICategoryQueryResult>(categoryQuery);
